import { render } from "./CodeEditor.vue?vue&type=template&id=71ff20a8&scoped=true"
import script from "./CodeEditor.vue?vue&type=script&lang=js"
export * from "./CodeEditor.vue?vue&type=script&lang=js"

import "./CodeEditor.vue?vue&type=style&index=0&id=71ff20a8&scoped=true&lang=css"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ff20a8"]])

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QBtnGroup,QBtn,QSpace,QCard,QInnerLoading,QSpinnerGears,QIcon});
